<template>
    <Head :title="seo.title">
        <meta head-key="description" name="description" :content="seo.description" />
        <meta head-key="robots" name="robots" :content="seo.robots" />
        <link head-key="canonical" rel="canonical" :href="seo.canonical" />

        <meta head-key="og:site_name" property="og:site_name" content="Clipfinder" />
        <meta head-key="og:title" property="og:title" :content="fullTitle" />
        <meta head-key="og:description" property="og:description" :content="seo.description" />
        <meta head-key="og:url" property="og:url" :content="seo.canonical" />
        <meta head-key="og:type" property="og:type" :content="seo.type" />
        <meta v-if="seo.image" head-key="og:image" property="og:image" :content="seo.image" />

        <meta head-key="twitter:card" name="twitter:card" content="summary_large_image" />
        <meta head-key="twitter:title" name="twitter:title" :content="fullTitle" />
        <meta head-key="twitter:description" name="twitter:description" :content="seo.description" />
        <meta v-if="seo.image" head-key="twitter:image" name="twitter:image" :content="seo.image" />
    </Head>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Head, usePage } from '@inertiajs/vue3'

interface SeoData {
    title: string
    description: string
    canonical: string
    image?: string
    type: string
    robots: string
}

const fallback: SeoData = {
    title: 'Clipfinder',
    description: 'Search podcast conversations and discover the moments that answer your questions.',
    canonical: window.location.href,
    type: 'website',
    robots: 'noindex, nofollow',
}

const page = usePage()
const seo = computed<SeoData>(() => (page.props.seo as SeoData | undefined) ?? fallback)
const fullTitle = computed(() => `${seo.value.title} - Clipfinder.com`)
</script>
